<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div style="display: flex;justify-content: center">
        <div style="width: 1400px;margin-top: 20px">
            <el-row>
                <el-col :span="24" class="condition-panel"
                        style="display: flex;flex-direction: row;justify-content: space-between;">
                    <el-col :span="22" style="display: flex;flex-direction: row;justify-content: end;">
                        <el-form :inline="true">
                            <el-form-item label="浏览时间" style="margin-right: 10px !important;">
                                <el-date-picker
                                        v-model="viewRecordSelect.viewRecord.createTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择操作时间"
                                        default-time="12:00:00">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="margin-left: 20px;" @click="reset()" type="danger">重置</el-button>
                                <el-button style="margin-left: 20px;" @click="getViewRecord(true)" type="primary">查询
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-col>
            </el-row>
            <div class="table-wrapper">
                <el-table
                        :header-cell-style="$store.state.style.table.headerCellStyle"
                        :cell-style="$store.state.style.table.cellStyle"
                        :header-row-style="$store.state.style.table.headerRowStyle"
                        :row-style="$store.state.style.table.rowStyle"
                        :row-class-name="tableClass"
                        border
                        key="ViewRecordManage"
                        width="100%"
                        :data="viewRecords">
                    <el-table-column label="ID" prop="id"></el-table-column>
                    <el-table-column label="浏览时间" prop="createTime"></el-table-column>
                    <el-table-column label="景点" prop="attraction.name"></el-table-column>
                    <el-table-column label="景点图片">
                        <template slot-scope="scope">
                            <img :src="$store.state.backendHost+scope.row.attraction.imgs.split(',')[0]"
                                 style="cursor: pointer"
                                 height="50px"/>
                        </template>
                    </el-table-column>
                    <el-table-column width="380" label="操作">
                        <template slot-scope="scope">
                            <div style="display: flex;justify-content: center;flex-direction: row">
                                <el-popover
                                        placement="top"
                                        key="ViewRecordManage"
                                        style="margin-left: 10px"
                                        v-model="scope.row.visible">
                                    <p style="text-align: center">真的要删除吗?</p>
                                    <div>
                                        <el-button type="danger" @click="deleteViewRecord(scope.row,scope.$index)">确定
                                        </el-button>
                                        <el-button type="success" @click="scope.row.visible=false">取消</el-button>
                                    </div>
                                    <el-button icon="el-icon-delete" type="danger" slot="reference"></el-button>
                                </el-popover>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="el-pg-wrapper">
                    <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page.sync="viewRecordSelect.pageVo.pageIndex"
                            :page-size.sync="viewRecordSelect.pageVo.pageSize"
                            @size-change="getViewRecord(false)"
                            @current-change="getViewRecord(false)"
                            :page-sizes="[5, 10, 50, 100]"
                            :total.sync="viewRecordSelect.pageVo.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ViewRecordManage",
    watch: {},
    data() {
        return {
            isFullscreen: false,
            fullscreenImage: '',
            role: this.$store.state.loginUser.role,
            viewRecordSelect: {
                viewRecord: {
                    userId: 0,
                    itemId: 0,
                    createTime: '',
                },
                pageVo: {
                    pageSize: 5,
                    pageIndex: 1,
                    total: 0
                }
            },
            viewRecord: {
                id: null,
                userId: 0,
                itemId: 0,
                createTime: '',
            },
            viewRecords: [],
            selectedViewRecord: {},
            viewRecordDialogMode: 1,
            viewRecordDialogVisible: false,
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    methods: {
        openFullscreen(image) {
            this.fullscreenImage = image;
            this.isFullscreen = true;
        },
        closeFullscreen() {
            this.isFullscreen = false;
            this.fullscreenImage = '';
        },
        reset() {
            this.viewRecordSelect.viewRecord = {}
            this.getViewRecord(true)
        },
        //crud
        insertViewRecord() {
            let data = JSON.stringify(this.viewRecord)
            this.$axios({
                url: "/viewRecord/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    this.viewRecord.id = r.data
                    this.viewRecords.push(this.viewRecord)
                    this.viewRecordSelect.pageVo.total++
                    this.$message.success('创建成功');
                } else {
                    this.$message.error('创建失败');
                }
            })
        },
        dup(o) {
            this.viewRecord = o
            this.insertViewRecord()
        },
        deleteViewRecord(viewRecord, index) {
            this.$axios({
                url: "/viewRecord/delete?id=" + viewRecord.id,
                method: 'get',
                headers: {'content-type': 'application/json'},
            }).then((r) => {
                if (r.data === 1) {
                    this.viewRecords.splice(index, 1)
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('删除失败');
                }
            })
        },
        modifyViewRecord() {
            let data = JSON.stringify(this.viewRecord)
            this.$axios({
                url: "/viewRecord/update",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data === 1) {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
            })
        },
        getViewRecord(resetPageIndex) {
            if (resetPageIndex) {
                this.viewRecordSelect.pageVo.pageIndex = 1
            }
            this.viewRecordSelect.viewRecord.userId = this.$store.state.loginUser.id
            let data = JSON.stringify(this.viewRecordSelect)
            this.$axios({
                url: "/viewRecord/select",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                this.viewRecords = r.data.viewRecords
                this.viewRecordSelect.pageVo.total = r.data.total
            })
        },
        handleViewRecordDialog(mode, viewRecord) {
            this.viewRecordDialogMode = mode
            this.viewRecordDialogVisible = true
            if (mode === 1) {
                this.viewRecord = {
                    id: null,
                    userId: 0,
                    itemId: 0,
                    createTime: '',
                }
            }
            if (mode === 2) {
                this.viewRecord = viewRecord
            }
        },

        //common
        tableClass({row, rowIndex}) {
            return rowIndex % 2 === 1 ? "even-row" : "no-even-row"
        },
    },
    mounted() {
        this.reset()
    },
}
</script>
<style scoped>
.el-radio-button__inner {
    border: 0 !important;
    border-radius: 0 !important;
    /*background-color: transparent !important;*/
}

.fullscreen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.fullscreen-image {
    max-width: 90%;
    max-height: 90%;
}

</style>